import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { useEffect } from 'react';
import { setExperimentEligibility } from '../../actions/ExperimentationActions';
import { FTS_0011_GROUP_PARAMETER_KEY, FTS_0011_GROUP_PARAMETER_OPTIONS, FTS_0011_TREATMENT_KEY } from '../../constants/experimentKeys';
import { useAppDispatch, useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { areExperimentsLoadingSelector, experimentByTreatmentKeySelector, hasExperimentsFetchSucceededSelector } from '../../selectors/ExperimentSelectors';
import { laboratoryClient } from '../laboratoryClient';
import { getIsAcceptanceTest } from '../testUtils';
const treatmentKey = FTS_0011_TREATMENT_KEY;
const groupParameterKey = FTS_0011_GROUP_PARAMETER_KEY;
const groupParameterOptions = FTS_0011_GROUP_PARAMETER_OPTIONS;
export const logFTS0011Exposure = () => {
  laboratoryClient.logExposure(treatmentKey);
};
export const useFTS0011Experiment = () => {
  const isAcceptanceTest = getIsAcceptanceTest();
  const experiment = useAppSelector(state => experimentByTreatmentKeySelector(state, treatmentKey));
  const areExperimentsLoading = useAppSelector(areExperimentsLoadingSelector);
  const hasExperimentsFetchSucceeded = useAppSelector(hasExperimentsFetchSucceededSelector);
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isMobile = useIsMobile();

  // Public experiment
  const isEligible = hasExperimentsFetchSucceeded && !isAcceptanceTest && !isAppAuth && !isMobile;
  const isControl = isEligible && (experiment === null || experiment === void 0 ? void 0 : experiment.parameters[groupParameterKey]) === groupParameterOptions.control;
  const isVariant = isEligible && (experiment === null || experiment === void 0 ? void 0 : experiment.parameters[groupParameterKey]) === groupParameterOptions.variant;
  return {
    isEligibleForFTS0011: isEligible,
    isFTS0011Control: isControl,
    isFTS0011Variant: isVariant,
    isFTS0011Fetched: hasExperimentsFetchSucceeded,
    isFTS0011Loading: areExperimentsLoading
  };
};

// Hook for logging exposure and returning experiment data
export const useFTS0011ExperimentAndLogExposure = () => {
  const experiment = useFTS0011Experiment();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (experiment.isEligibleForFTS0011) {
      logFTS0011Exposure();
      dispatch(setExperimentEligibility({
        treatmentKey: FTS_0011_TREATMENT_KEY,
        isEligible: true,
        group: experiment.isFTS0011Control ? 'control' : 'variant',
        isPublic: true,
        isInApp: false
      }));
    }
  }, [experiment.isEligibleForFTS0011, dispatch, experiment.isFTS0011Control]);
  return experiment;
};